import { FaChartPie, FaSpinner, FaTrash } from "react-icons/fa";

export const BtnComponent = ({
    btnType = "primary",
    type = "button",
    text = "",
    btnRef = null,
    size = "md",
    className = "",
    loading = false,
    ...btnProps
}) => {
    const defaultCss = "border rounded flex items-center";
    let sizeCss = "py-1 px-2.5";
    if (size === "md") {
      sizeCss = "pr-2.5 pl-2 py-1.5";
    } else if (size === "sm") {
      sizeCss = "text-sm px-2 py-0.5";
    } else if (size === "xs") {
      sizeCss = "text-xs px-1 py-0.5";
    } else if (size === "tiny") {
      sizeCss = "text-xs p-0";
    }
  
    const typeCss = {
      primary_theme: 'py-2 px-2.5 font-normal rounded text-[14px] text-white border border-violet-700 bg-bg-primary hover:bg-violet-700',
      delete:
        "py-1 px-2.5 font-normal rounded text-[14px] text-danger-hover border-danger-hover border hover:bg-danger-hover hover:text-white",
      cancel:
        "py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border hover:bg-gray-e5 hover:text-black-300",
      blue: "text-white bg-violet-700 hover:bg-violet-700 dark:bg-violet-700 dark:hover:bg-violet-700 border-violet-700",
      primary:
        " font-normal border border-ethizo_primary rounded bg-ethizo_primary text-[14px] text-white hover:bg-primary-hover hover:border-primary-hover",
      cyan: "text-white bg-cyan-600 hover:bg-cyan-800 border-cyan-500",
      chief: "text-white bg-[#b17474] hover:bg-[#8c5c5c] border-[#b17474]",
      default: "bg-white hover:bg-gray-100 text-gray-500 border-gray-400",
      danger:
        "font-normal rounded text-[14px] text-white border-amber-600 border bg-amber-600 hover:bg-amber-700",
      success:
        "font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover",
      remove:
        "text-orange-700 bg-white hover:bg-amber-100 border-stone-300 p-0.1",
    };
  
    return (
      <>
        {btnType === "upload" ? (
          <div className={`${btnType === "upload" ? "relative ml-5" : "flex"}`}>
            <span className="absolute">
              <FaChartPie className="text-white my-2 mx-1" />
            </span>
  
            <button
              ref={btnRef}
              type={type}
              {...btnProps}
              className="inline-flex cursor-pointer justify-center rounded border border-transparent bg-teal1000 pl-6 pr-2 py-1 text-white focus:outline-none hover:bg-primary-hover"
            >
              {text}
            </button>
          </div>
        ) : (
          <button
            ref={btnRef}
            type={type}
            {...btnProps}
            className={`${
              btnProps.disabled && "opacity-50 cursor-not-allowed"
            } ${className} ${defaultCss} ${typeCss[btnType]} ${sizeCss}`}
          >
            {btnType === "remove" ? <FaTrash /> : text}{" "}
            {loading ? <FaSpinner className="animate-spin text-green-300-500 ml-1" size={20} /> : ""}
          </button>
        )}
      </>
    );
};